import { connect } from 'react-redux';
import { format } from 'date-fns';
import { Actions as PAYROLLACTIONS } from '../../store/actions/payrollActions';
import { XMarkIcon } from '@heroicons/react/20/solid'

import Spinner from '../common/Spinner';


const ClearPayslipModal = ({
    modalOpen,
    closeModal,
    clearingPayslip,
    clearPayslip
}) => {

    if(!modalOpen) return null;

    return (
        <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{display: "block",background: "rgba(0,0,0,0.4)",overflow:"scroll"}}>
            <div className="modal-dialog">
                <div className="modal-content" >
                    <div className="block block-themed block-transparent remove-margin-b">
                        <div className="block-header bg-danger">
                            <ul className="block-options">
                                <li>
                                    <button className="close" type="button" aria-label="Close" onClick={() => closeModal()}><XMarkIcon className="h-6 w-6 mr-3 text-white" /></button>
                                </li>
                            </ul>
                            <h3 className="block-title">Confirm</h3>
                        </div>
                        <div className="modal-body"> 
                            <div className="clearfix"></div>
                                Are you sure you want to clear all allowances and data for {modalOpen?.employeeName} {modalOpen?.employeeSurname}'s Payslip?

                                <br/>
                                <br/>
                                This action cannot be undone, once cleared any pre-existing allowance data cannot be recovered.
                                <br/>
                                <br/>
                                We recommend reloading the page one you clear the respective payslips.
                            <div className="clearfix"></div> <br/>
                            <div className="row">      

                                {
                                    clearingPayslip && 
                                    <Spinner 
                                         style={{width: '2rem',height: '2rem', verticalAlign: 'middle',marginTop: 20}}
                                         className="animate-spin -ml-1 mr-3 h-5 w-5 text-success right"/>
                                }
                                {!clearingPayslip &&
                                    <div className="col-xs-12 text-right">   
                                        <button className="btn btn-danger pull-right" type="button" id="reset-payroll" onClick={() => { clearPayslip(modalOpen);}}>Clear Payslip</button>
                                    </div>
                                }     
                            </div> 
                        </div> 
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        modalOpen: state.payroll?.clearPayslipModal,
        clearingPayslip: state.payroll?.clearingPayslip
    }
}

const mapDispatchToProps = dispatch => ({
    clearPayslip: (employee) => dispatch(PAYROLLACTIONS.clearPayslip(employee)),
    closeModal: () => dispatch(PAYROLLACTIONS.showClearPayslipModal(false))
})

export default connect(mapStateToProps, mapDispatchToProps)(ClearPayslipModal);